import React from 'react';
import { useParams } from 'react-router-dom';
import { Divider, Grid } from '@material-ui/core';
import Layout from '../../common/Layout';
import PageHeader from '../../common/components/PageHeader/PageHeader';
import QscProfile from '../../common/components/QscProfile/QscProfile';
import QscLearningTopics from '../../common/components/QscLearningTopics/QscLearningTopics';
import PartnersBlock from '../../common/components/PartnersBlock/PartnersBlock';
import QscSkillProgress from '../../common/components/QscSkillProgress/QscSkillProgress';
import LoadingSpinner from '../../common/components/LoadingSpinner/LoadingSpinner';
import { useQualificationScorecard } from '../../hooks/useQualificationScorecard';
import { useQualificationScorecardById } from '../../hooks/useQualificationScorecardById';
import { useQualificationDimensionProgress } from '../../hooks/useQualificationDimensionProgress';
import useAppStore from '../../store/appStore';

const QualificationScoreCard = () => {
  const { id } = useParams();
  const userData = useAppStore(state => state.user);
  const userRole = userData?.me?.userRole;
  const [selectedGroupId, setSelectedGroupId] = React.useState(null);
  console.log('id', id);
  // Use the URL id if present, otherwise fall back to the logged-in user's key
  const userId = id || userData?.me?.key;
  const ownQuery = useQualificationScorecard(!id);
  const byIdQuery = useQualificationScorecardById(id);
  const { data: skillProgressData } = useQualificationDimensionProgress(selectedGroupId, userId);

  const { isFetching: isLoading, error, data } = id ? byIdQuery : ownQuery;

  const qsc = data?.qualificationScoreCard;
  const badges = skillProgressData?.qualificationDimensionProgress || [];

  return (
    <Layout>
      {isLoading ? (
        <LoadingSpinner styles={{ paddingTop: 65 }} />
      ) : error ? (
        <div>Error! {error?.message || 'Unknown error'}</div>
      ) : qsc ? (
        <>
          <PageHeader
            title="Qualification Scorecard: Dynamic Validation of Skills"
            subTitle="The Qualification Scorecard shows your aggregated professional proficiencies to attach to your CV or share it on any Job Platform.
Browse your results for every Qualification. Check your skill progress while completing the Challenges in the Competence Units"
          />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
              <QscProfile
                expirationDate={qsc.expirationDate}
                serialNumber={qsc.serialNumber}
                username={qsc.username}
                photo={qsc.photo}
                badges={badges}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
              <QscLearningTopics careerPaths={qsc.careerPaths} userRole={userRole} onGroupChange={setSelectedGroupId} />
              <QscSkillProgress skillProgress={badges} />
            </Grid>
          </Grid>
          <Divider style={{ textAlign: 'center', maxWidth: 960, margin: '0 auto', marginTop: 110, marginBottom: 50 }} />
          <PartnersBlock />
        </>
      ) : null}
    </Layout>
  );
};

export default QualificationScoreCard;
